import { render, staticRenderFns } from "./ActivityCreate.vue?vue&type=template&id=255b6405&scoped=true"
import script from "./ActivityCreate.vue?vue&type=script&lang=js"
export * from "./ActivityCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b6405",
  null
  
)

export default component.exports